"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../redux/slices/expertsSlice");
const directorySearch_1 = __importDefault(require("../../../genericComponents/directorySearch/directorySearch"));
const common_1 = require("../../../../../utils/common");
const expertsSlice_2 = require("../../../../../redux/slices/expertsSlice");
class ServicesFilter extends directorySearch_1.default {
    constructor() {
        super(...arguments);
        this.directoryType = 'serviceExperts';
        this.getServiceExperts = (filter) => {
            this.props.getServiceExperts(filter);
        };
    }
    init() {
        const serviceId = parseInt(common_1.urlPrams("id"));
        const name = common_1.urlPrams("name");
        const parentId = parseInt(common_1.urlPrams("parent_id"));
        const isLang = common_1.urlPrams("isLang");
        this.props.getServices();
        this.props.getLocations();
        this.props.setExperts({
            experts: [],
            count: 0
        });
        let defaultFilter = Object.assign(Object.assign({}, this.props.experts.filter), { selectedFilters: [], selectedStates: [], q: '', offset: parseInt(common_1.urlPrams("page")) - 1 || 0, limit: this.props.experts.filter.limit });
        if (common_1.isMobileBrowser().check || common_1.ifMobile()) {
            window.addEventListener("beforeunload", (e) => {
                localStorage.setItem(`service_filter`, JSON.stringify(defaultFilter));
            });
        }
        let filter = localStorage.getItem("service_filter");
        if (serviceId && name && parentId) {
            defaultFilter.selectedFilters = [{ id: serviceId, service_id: parentId, name: name, parent_id: parentId, isLang: !!isLang }];
        }
        else if (filter) {
            defaultFilter = JSON.parse(filter);
        }
        this.getServiceExperts(defaultFilter);
    }
}
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        experts,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getServices: () => dispatch(expertsSlice_1.getServices()),
        getLocations: () => dispatch(expertsSlice_1.getLocations()),
        getServiceExperts: (data) => dispatch(expertsSlice_1.getServiceExperts(data)),
        setExperts: (data) => dispatch(expertsSlice_1.setExperts(data)),
        resetMounted: () => dispatch(expertsSlice_2.resetMounted())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ServicesFilter);
